import { useCallback } from "react";
import StandaloneSurveyPageLayout from "components/v3/layouts/StandaloneSurveyPageLayout";
import KitRequestSurvey from "../../sharedComponents/surveys/KitRequestSurvey";
import { trackSurveyAbandonAttempted } from "analytics";

const KitRequestSurveyPage = (): React.ReactElement => {
  const handleExitClick = useCallback(() => {
    trackSurveyAbandonAttempted({
      surveyId: "kit-request-questions",
      workflow: "kit_request_survey",
      action: "opened_exit_modal"
    });
  }, []);

  const handleExitModalClose = useCallback(() => {
    trackSurveyAbandonAttempted({
      surveyId: "kit-request-questions",
      workflow: "kit_request_survey",
      action: "cancelled_exit"
    });
  }, []);

  return (
    <StandaloneSurveyPageLayout
      onExitClick={handleExitClick}
      onExitModalClose={handleExitModalClose}
      pageTitle="Kit request survey"
      showLogoHeader
    >
      <KitRequestSurvey />
    </StandaloneSurveyPageLayout>
  );
};

export default KitRequestSurveyPage;
